import {cr} from 'fire-wind-water';
import {Touch} from '../touch';

export function wapWrap(list, that) {
  return [
    {
      h: 'div', c: 'picker-toolbar picker-hairline',
      z: [
        {
          h: 'div', c: 'picker-cancel', html: '取消',
          e: [
            {
              t: 'touchstart', e: () => {
                that.destroy();
              }
            }
          ]
        },
        {
          h: 'div', c: 'picker-confirm', html: '确定',
          e: [
            {
              t: 'touchend', e: () => {
                that.changeModel();
              }
            }
          ]
        }
      ]
    },
    {
      h: 'div', c: 'picker-columns',
      z: [
        ...list,
        {
          h: 'div', c: 'picker-mask'
        },
        {
          h: 'div', c: 'picker-frame picker-hairline'
        }
      ]
    }
  ];
}

export function column(list, cn, id) {
  const arr = [];
  cr.each(list, (d) => {
    arr.push({
      h: 'li', c: 'picker-item', html: d, s: `line-height: 44px;`
    });
  });
  const touch = new Touch();
  touch.changeIndex = cn;
  return {
    touch: touch,
    list: {
      h: 'div', c: 'picker-list',
      z: [
        {
          h: 'ul',
          c: 'picker-list-wrapper',
          id: id,
          s: 'transform: translate3d(0px, 0px, 0px); transition-duration: 0ms;',
          z: arr,
          e: [
            {
              t: 'touchstart',
              e: function(ev) {
                touch.start(ev, this);
              }
            },
            {
              t: 'touchmove',
              e: function(ev) {
                touch.move(ev);
              }
            },
            {
              t: 'touchend',
              e: function(ev) {
                touch.end(ev);
              }
            },
            {
              t: 'touchcancel',
              e: function(ev) {
                touch.end(ev);
              }
            },
            {
              t: 'transitionend',
              e: function(ev) {
                touch.onTransitionEnd(ev);
              }
            }
          ]
        }
      ]
    }
  };
}

export function columnTip(s) {
  return {
    h: 'div', c: 'picker-list',
    z: [
      {
        h: 'ul',
        c: 'picker-list-wrapper',
        s: 'transform: translate3d(0px, 0px, 0px); transition-duration: 0ms;',
        z: [
          {
            h: 'li', c: 'picker-item', html: s
          }
        ]
      }
    ]
  };
}